export const AGREGAR_PRODUCTO = "AGREGAR_PRODUCTO";
export const AGREGAR_PRODUCTO_EXITO = "AGREGAR_PRODUCTO_EXITO";
export const AGREGAR_PRODUCTO_ERROR = "AGREGAR_PRODUCTO_ERROR";

export const COMENZAR_DESCARGA_PRODUCTOS = "COMENZAR_DESCARGA_PRODUCTOS";
export const DESCARGA_PRODUCTOS_EXITO = "DESCARGA_PRODUCTOS_EXITO";
export const DESCARGA_PRODUCTOS_ERROR = "DESCARGA_PRODUCTOS_ERROR";

export const OBTENER_PRODUCTO_ELIMINAR = "OBTENER_PRODUCTO_ELIMINAR";
export const PRODUCTO_ELIMINADO_EXITO = "PRODUCTO_ELIMINADO_EXITO";
export const PRODUCTO_ELIMINADO_ERROR = "PRODUCTO_ELIMINADO_ERROR";

export const OBTENER_PRODUCTO_EDITAR = "OBTENER_PRODUCTO_EDITAR";
export const COMENZAR_EDICION_PRODUCTO = "COMENZAR_EDICIÓN_PRODUCTO";
export const PRODUCTO_EDITADO_EXITO = "PRODUCTO_EDITADO_EXITO";
export const PRODUCTO_EDITADO_ERROR = "PRODUCTO_EDITADO_ERROR";

export const MOSTRAR_ALERTA = "MOSTRAR_ALERTA";
export const OCULTAR_ALERTA = "OCULTAR_ALERTA";
